// extracted by mini-css-extract-plugin
export default {"container":"FormProgressBar_container__REyZ5","progress":"FormProgressBar_progress__y1lAK"};